import React from 'react';

const Logo = ({ className = "h-12" }) => {
  // Official newly uploaded standalone transparent logo
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/4948ae8bd3a71eaecd010e3b75a418c9afeda68ebd57283642e35d04cbb3fca3a3104393b4fae87688db585a45c44e03/images/aW1hZ2UvcG5n/f2816b8f9068b009235ee46901abd1ec.png";
  
  return (
    <img 
      src={logoUrl} 
      alt="EPOQ Assets" 
      className={`${className} object-contain`}
      // Deliberately avoiding any CSS filters to preserve the exact uploaded artwork
    />
  );
};

export default Logo;